import { EditIcon, InfoIcon } from "../../assets/icons";
import { getDate } from "../../utils/getStrDate.js";
import { numberWithSpaces } from "../../utils/numberWithSpaces.js";
import { ProgressCircle } from "../progressCircle/progressCircle.jsx";
import { Text } from "../text/text.jsx";

import styles from "./progressBar.module.css"

export const ProgressBar = ({ title, date, sold, target, onAction = null, onDelete = null }) => {
    const k = sold / target;
    const actionHandler = onAction || onDelete;

    return (
        <div className={styles.progressbar_container}>
            <div className={styles.progressbar_header}>
                <Text as="div" variant="captionStrong" className={styles.progressbar_title} transform="capitalize" clamp={2}>{title}</Text>
                {
                    !!actionHandler &&
                    <EditIcon style={{ flex: "0 0 auto" }} onClick={actionHandler} />
                }
            </div>
            <div className={styles.progressbar_info}>
                <div className={styles.progressbar_info_container}>
                    <Text as="div" variant="caption" className={styles.progressbar_info_title}>Продано</Text>
                    <Text as="div" variant="captionStrong" className={styles.progressbar_info_value}>{numberWithSpaces(sold)} ₽</Text>
                </div>
                <div className={styles.progressbar_info_container}>
                    <Text as="div" variant="caption" className={styles.progressbar_info_title}>План</Text>
                    <Text as="div" variant="captionStrong" className={styles.progressbar_info_value}>{numberWithSpaces(target)} ₽</Text>
                </div>
            </div>
            <ProgressCircle
                progress={k}
            >
                <div className={styles.progressbar_circle_info}>
                    <Text as="div" variant="h1" className={styles.progressbar_circle_percent} align="center">
                        {(Number(k) * 100).toFixed(0)}%
                    </Text>
                    <Text as="div" variant="body" className={styles.progressbar_circle_date} align="center">
                        {getDate(date)}
                    </Text>
                </div>
            </ProgressCircle>
            <InfoIcon className={styles.progressbar_info_icon} />
        </div>
    );
}